export default __webpack_public_path__ + "static/media/shopLightMode.1489fd05.svg";